import { parseApiError, regulatorySessionGeneration } from "./regulatoryApi"
export async function workflowRequest<T>(
  path: string,
  signal?: AbortSignal,
  method = "GET",
  body?: unknown,
  root = false,
): Promise<T> {
  const generation = regulatorySessionGeneration()
  const multipart = typeof FormData !== "undefined" && body instanceof FormData
  const response = await fetch(`/api/${root ? "" : "v2/"}${path}`, {
    method,
    signal,
    cache: "no-store",
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      ...(body === undefined || multipart ? {} : { "Content-Type": "application/json" }),
    },
    body: body === undefined ? undefined : multipart ? (body as FormData) : JSON.stringify(body),
  })
  if (generation !== regulatorySessionGeneration())
    throw new DOMException("La session a changé", "AbortError")
  if (!response.ok) {
    if (response.status === 401) window.dispatchEvent(new Event("cloud-session-expired"))
    throw parseApiError(await response.text(), response.status)
  }
  const value = (await response.json()) as T
  if (generation !== regulatorySessionGeneration())
    throw new DOMException("La session a changé", "AbortError")
  return value
}
